import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Complete Car Care",
      description:
        "Get all-in-one automotive services - from diagnostics to high-quality spare part replacements. We ensure your car receives the expert attention it deserves.",
      icon: "Wrench",
      badge: "Complete Care",
    },
    {
      id: 2,
      title: "Expert Team",
      description:
        "Our technicians combine decades of experience with deep product knowledge. We guarantee precision installation and after-sales support for every part we supply.",
      icon: "Award",
      badge: "Expert Team",
    },
    {
      id: 3,
      title: "Genuine Quality Assurance",
      description:
        "We deal only in OEM and certified spare parts - ensuring the best fit, performance, and safety for every make and model.",
      icon: "ShieldCheck",
      badge: "Trusted Quality",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Services We Offer
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Your <b>One-Stop Destination</b> for Excellence, Expertise, and Genuine Care.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl shadow-automotive-sm hover:shadow-automotive-lg transition-all duration-300 border border-border p-6 flex flex-col"
            >
              {/* Icon & Badge */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center justify-center w-12 h-12 bg-accent rounded-lg">
                  <Icon name={service.icon} size={28} color="white" />
                </div>
                <span className="px-3 py-1 bg-accent/10 text-accent text-xs font-semibold rounded-full">
                  {service.badge}
                </span>
              </div>

              {/* Title */}
              <h3 className="font-semibold text-lg text-text-primary mb-2">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-text-secondary flex-1">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
